export default __webpack_public_path__ + "static/media/kitchen5-afterB-768w.3843b316.webp";